// extracted by mini-css-extract-plugin
export default {"terms":"vwbqV","header":"SMPLF","title":"YpoC3","body":"LobwO"};